import './slider.scss';

import Swiper from 'swiper';
import { tryParseJSON } from '../../utilities/js/helper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class Slider {
    constructor($element) {
        this.$slider = $element;
        this.$slides = this.$slider.querySelectorAll('.swiper-slide');
        this.slider = null;
        this.sliderActive = false;

        this.sliderSettings = this.$slider.getAttribute('data-slider-settings');
        if (this.sliderSettings) {
            this.sliderSettings = tryParseJSON(this.sliderSettings);
        }
    }

    initialize() {
        if (this.$slides.length > 1) {
            this.checkSize();
            this.setEvents();

            this.$slider.classList.add('slides__items--length-' + this.$slides.length);
        }
    }

    checkSize() {
        if (this.sliderSettings && 'disable' in this.sliderSettings) {
            if (window.mediaMatchHandler[this.sliderSettings.disable].matches) {
                this.destroySlider();
            } else {
                if (this.slider === null) {
                    this.initSlider();
                }
            }
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    setEvents() {
        [1680, 1440, 1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    setAdditionalSlideClasses(swiper) {
        swiper.slides.forEach(($slide, index) => {
            $slide.classList.toggle('swiper-slide-before', index < swiper.activeIndex);
            $slide.classList.toggle('swiper-slide-after', index > swiper.activeIndex);
        });
    }

    improveAccessibility(swiper) {
        swiper.slides.forEach(($slide, index) => {
            const slideIsActive = index === swiper.activeIndex;
            $slide.setAttribute('aria-hidden', !slideIsActive);
            slideIsActive ? $slide.removeAttribute('disabled') : $slide.setAttribute('disabled', '');
        });
    }

    initSlider() {
        this.sliderActive = true;
        this.$progressbar = this.$slider.querySelector('.swiper-pagination-progressbar-fill');

        const updateProgressbar = (index) => {
            const progress = 1 / this.$slides.length * (index + 1);
            if (this.$progressbar) {
                this.$progressbar.style.transform = 'scaleX(' + progress + ')';
            }
        };

        this.$prevButton = this.$slider.querySelector('.swiper-button-prev');
        this.$nextButton = this.$slider.querySelector('.swiper-button-next');
        this.$fraction = this.$slider.querySelector('.swiper-pagination-fraction');

        this.slider = new Swiper(this.$slider, {
            autoHeight: true,
            modules: [A11y, Navigation, Pagination, Keyboard],
            a11y: true,
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            slideToClickedSlide: true,
            speed: 500,
            centeredSlides: true,
            centerInsufficientSlides: true,
            pagination: {
                el: this.$fraction,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
            on: {
                init: (swiper) => {
                    updateProgressbar(swiper.activeIndex);
                    this.setAdditionalSlideClasses(swiper);
                    this.improveAccessibility(swiper);
                },
                slideChange: (swiper) => {
                    this.setAdditionalSlideClasses(swiper);
                    this.improveAccessibility(swiper);
                },
                slideChangeTransitionStart: (swiper) => {
                    updateProgressbar(swiper.activeIndex);
                },
                lock: (swiper) => {
                    if (swiper.isLocked) {
                        this.$slider.classList.add('swiper-locked');
                    }
                },
                unlock: (swiper) => {
                    if (!swiper.isLocked) {
                        this.$slider.classList.remove('swiper-locked');
                    }
                }
            }
        });
    }

    destroySlider() {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
            this.sliderActive = false;

            if (this.$fraction) {
                this.$fraction.innerHTML = '';
            }
        }
    }
}

export { Slider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$slider = $context.querySelectorAll('[data-slider="root"]');

        for (let i = 0; i < $$slider.length; i++) {
            const slider = new Slider($$slider[i]);
            slider.initialize();
        }
    }
});
